import ArrowLeft from "../../assets/icons/Arrow/ArrowLeft";
import Loading from "../../assets/icons/Loading";
import Tags from "../../components/Tags/Tags";
import { getProducts } from "../../services/productService";
import { getUser } from "../../services/userService";
import { refreshAccessToken } from "../../store/slice/authSlice";
import { CategoryInfo } from "../../store/slice/productsSlice";
// import { ProductType } from "../../store/slice/productsSlice";
import { AppDispatch, RootState } from "../../store/store";
import "./Products.scss";
import LeftPanel from "./components/LeftPanel/LeftPanel";
import ProductItem from "./components/ProductItem/ProductItem";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const Products = () => {
  const { category, subcategory } = useParams();
  const navigate = useNavigate();
  const { categories, products, loading } = useSelector(
    (state: RootState) => state.products
  );
  const dispatch = useDispatch<AppDispatch>();

  const { user } = useSelector((state: RootState) => state.user);
  const { access_token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (access_token && !user?.id) {
      dispatch(getUser(access_token));
    }
  }, [user, access_token, dispatch]);

  useEffect(() => {
    dispatch(getProducts({ category, subcategory }));
  }, [category, subcategory, dispatch]);

  useEffect(() => {
    dispatch(refreshAccessToken());
  }, [dispatch]);

  const name = useMemo(() => {
    if (subcategory) {
      return categories
        .find((cat) => cat.code === category)
        ?.subcategories.find((sub) => sub.code === subcategory)?.name;
    } else return categories.find((cat) => cat.code === category)?.name;
  }, [category, subcategory, categories]);

  const handleClick = (tag: CategoryInfo) => {
    navigate(`/category-product/${category}/${tag.code}`);
  };

  return (
    <div className="products-container">
      <div>
        <LeftPanel />
      </div>
      <div className="category-list">
        <div className="category-name">
          {(subcategory || category) && (
            <ArrowLeft
              onClick={() =>
                navigate(
                  !subcategory && category
                    ? "/"
                    : `/category-product${subcategory ? `/${category}` : ""}`
                )
              }
            />
          )}
          <h1>{name?.toUpperCase()}</h1>
        </div>
        {!subcategory && (
          <div className="tags-subcategories">
            <Tags
              tags={
                categories.find((cat) => cat.code === category)?.subcategories
              }
              onClick={handleClick}
            />
          </div>
        )}
        {loading ? (
          <div className="loading">
            <Loading />
          </div>
        ) : (
          <div>
            <div className="container-items">
              {products?.items?.map((product, index) => (
                <ProductItem
                  {...product}
                  key={`product-item-${product.Code}`}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
